module.exports = __webpack_public_path__ + "static/media/3ds-dark.945a47bd.png";